module.exports = __webpack_public_path__ + "img/transgender.dd8d5e0a.svg";